import React, {useEffect, useRef, useState} from 'react';

import moment from 'jalali-moment';
import ChatHeader from './chatHeader';
import InfinitScroll from '../../../components/infinitScroll';
import classNames from 'classnames';
import ChatmsgItem from './chatmsgItem';
import ChatInputArea from './chatInputArea';
import ImageVideoPreview from './imageVideoPreview';
import {IChatReplyState, IImageFileUpload} from './type';
import {useSelector} from 'react-redux';
import {RootState} from '../../../store/redux';
import ChatReport from './chatReport';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import ReplyProduct from './chatmsgItem/replyProduct';
// import TimeDifferenceConvertor from '../../../utilities/helper/timeConvertor';
import DotsLoading from '../../../components/dotsLoading';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {BottomSheet} from 'react-spring-bottom-sheet';
import useDeleteChatItem from '../../../services/hookService/chats/deleteChatItem/useDeleteChatItem';
import useGetMessagesChats from '../../../services/hookService/chats/getMessagesChats/useGetMyChats';
import useGetUserChatDetail from '../../../services/hookService/chats/getUserCHatDetail/useGetUserCHatDetail';
import EmptyList from '../../../assets/image/shared/empty_list.svg';

import './style.css';
// import {getPersianDateTime} from '../../../utilities/helper/GetPersianDateTime';
import {calculateDate} from '../myAds/buy';

export interface IIsDeleteChat {
  isOpen: boolean;
  data: {guid: string; chatItem: string} | null;
}
const ChatsForm = () => {
  const {guid} = useParams();
  const navigate = useNavigate();
  const [hash, setHash] = useState<string>();
  const {state} = useLocation();

  const {cropedImage, imageFile: reduxImageFile} = useSelector(
    (state: RootState) => state.imageCropedit,
  );

  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [dropDownIsOpen, setDropDownIsOpen] = useState(false);
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [imageFile, setImageFile] = useState<IImageFileUpload>();
  const [file, setFile] = useState<File | undefined>();
  const [currentVideoPlaying, setcurrentVideoPlaying] = useState<string>();
  const [replyingChat, setReplyingChat] = useState<IChatReplyState>();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeleteChat, setIsDeleteChat] = useState<IIsDeleteChat>({
    isOpen: false,
    data: null,
  });
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView();
  };
  const itemsRef = useRef([]);

  useEffect(() => {
    cropedImage && setDropDownIsOpen(true);
    !cropedImage && !reduxImageFile && setDropDownIsOpen(false);
  }, [cropedImage]);

  useEffect(() => {
    scrollToBottom();
  }, []);

  useEffect(() => {
    let timeisOut: NodeJS.Timeout;
    if (window.location.hash !== '') {
      setTimeout(() => navigate(-1), 1000);
      setHash(undefined);
    }
    window.addEventListener('hashchange', e => {
      if (window.location.hash) {
        setHash(window.location.hash);
      }
    });

    return () => {
      window.removeEventListener('hashchange', e => {
        setHash(undefined);
        navigate(-1);
      });
      clearTimeout(timeisOut);
    };
  }, [hash]);

  const {data, isLoading, fetchNextPage, refetch, hasNextPage} =
    useGetMessagesChats(guid);

  const {userChatDetailData, userChatDetailIsLoading} =
    useGetUserChatDetail(guid);

  const nowTime = moment(moment(), 'YYYY/MM/DD').format('YYYY/MM/DD');

  const groupedTech = data?.pages
    .flatMap(x => x.results)
    .reduce((acc: Record<string, Array<IMessagesChatsResults>>, item) => {
      const timeconverted = moment(item?.created_at, 'YYYY/MM/DD').format(
        'YYYY/MM/DD',
      );

      if (!acc[timeconverted]) {
        acc[timeconverted] = [];
      }
      acc[timeconverted].push(item);

      return acc;
    }, {});

  const {mutate, isLoading: isloadingDelete} = useDeleteChatItem({
    onSuccess: () => {
      refetch && refetch();
      setIsDeleteChat({
        isOpen: false,
        data: null,
      });
    },
  });

  const [parentChatGuid, setParentChatGuid] = useState('');

  const calculateDateDifference = (givenDate: string) => {
    const givenDateObject = new Date(givenDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    //@ts-ignore
    const diffMilliseconds = today - givenDateObject;
    if (Math.floor(diffMilliseconds / (1000 * 60 * 60 * 24)) < 30) {
      return `${Math.floor(diffMilliseconds / (1000 * 60 * 60 * 24))} روز پیش`;
    } else {
      return calculateDate(givenDate);
    }
  };

  useEffect(() => {
    if (parentChatGuid !== '') {
      //@ts-ignore
      const targetElement = itemsRef.current[parentChatGuid];
      const chatBox = targetElement.querySelector('div[id] > #chatBox');

      if (targetElement && chatBox) {
        //@ts-ignore
        chatBox.style.backgroundColor = '#bdd6a3';
        targetElement.scrollIntoView({behavior: 'smooth'});

        setTimeout(() => {
          if (chatBox) {
            //@ts-ignore
            chatBox.style.backgroundColor = '';
          }
        }, 800);
      }
    }
  }, [parentChatGuid]);

  useEffect(() => {
    if (!guid) return;
    refetch();

    const refetchChatInterval = setInterval(refetch, 10000);

    return () => clearInterval(refetchChatInterval);
  }, [refetch, guid, 10000]);

  const isPageLoading = isLoading || userChatDetailIsLoading || isloadingDelete;

  return (
    <div className="flex flex-col justify-between w-full h-full ">
      <ChatHeader
        supplierGuid={state?.supplierGuid}
        isDeleteOpen={isDeleteOpen}
        setIsDeleteOpen={setIsDeleteOpen}
        isLoading={userChatDetailIsLoading}
        isReportOpen={isReportOpen}
        chatId={guid}
        name={userChatDetailData?.receiver_profile?.name || ''}
        imgUrl={userChatDetailData?.sender_profile?.profile_image || ''}
        setIsReportOpen={setIsReportOpen}
      />
      <div className="flex w-full flex-col-reverse gap-3 h-full overflow-y-scroll  relative">
        {dropDownIsOpen && (
          <ImageVideoPreview
            replyingChat={replyingChat}
            imageFile={imageFile}
            file={file}
            setFile={setFile}
            setDropDownIsOpen={setDropDownIsOpen}
            setImageFile={setImageFile}
          />
        )}
        <div ref={messagesEndRef} />

        {data?.pages[0].results ? (
          <InfinitScroll
            isEndSeenReverse
            isloading={isLoading}
            onWatchEnd={() => !isLoading && hasNextPage && fetchNextPage()}
          >
            {/* {data?.pages
              .flatMap(x => x.results)
              .reverse()
              ?.map((item, index) => {
                const timeconverted =
                  item?.created_at &&
                  moment(item?.created_at, 'YYYY/MM/DD').format('YYYY/MM/DD');

                return (
                  <div
                    className={classNames('flex flex-col w-full', {
                      'items-end':
                        String(userChatDetailData?.sender_profile.username) !==
                        String(item?.sender),
                      'items-start':
                        String(userChatDetailData?.sender_profile.username) ===
                        String(item?.sender),
                      flashchat: hash && hash.replace('#', '') === item.guid,
                    })}
                    key={index}
                  >
                    {item.product_info && (
                      <ReplyProduct
                        chat={item}
                        is_author={
                          String(
                            userChatDetailData?.sender_profile.username,
                          ) === String(item?.sender)
                        }
                      />
                    )}
                    {((item.message !== null && item.message !== '') ||
                      item?.file_info !== null) && (
                      <div
                        className={classNames(
                          'flex flex-col gap-4 px-4  py-2',
                          {
                            'items-start':
                              String(
                                userChatDetailData?.sender_profile.username,
                              ) === String(item?.sender),

                            'w-full': item.file_info,
                          },
                          {
                            'items-end':
                              String(
                                userChatDetailData?.sender_profile.username,
                              ) !== String(item?.sender),
                            'w-fit': !item.file_info,
                          },
                        )}
                        key={index}
                      >
                        <ChatmsgItem
                          userChatDetailData={userChatDetailData}
                          guid={item?.guid}
                          chat={item}
                          currentVideoPlaying={currentVideoPlaying}
                          replyingChat={replyingChat}
                          isDeleteChat={isDeleteChat}
                          setIsDeleteChat={setIsDeleteChat}
                          refresh={refetch}
                          setReplyingChat={setReplyingChat}
                          setcurrentVideoPlaying={setcurrentVideoPlaying}
                        />
                      </div>
                    )}
                    {groupedTech &&
                      timeconverted &&
                      groupedTech[timeconverted].length > 0 &&
                      groupedTech[timeconverted][
                        groupedTech[timeconverted].length - 1
                      ].guid === item.guid && (
                        <div className="d-flex w-full justify-center my-3">
                          <div className="bg-gray-700 rounded-xl p-2 text-white text-xs">
                            {nowTime === timeconverted
                              ? 'امروز'
                              : TimeDifferenceConvertor(
                                  item.created_at as string,
                                )}
                          </div>
                        </div>
                      )}
                  </div>
                );
              })} */}
            <>
              {groupedTech &&
                Object.keys(groupedTech).map((elem, index) => {
                  return (
                    <div key={index}>
                      <div className="w-full my-2 flex justify-center items-center">
                        <span className="text-sm bg-gray-600 rounded-full text-center px-2 py-1 text-white">
                          {' '}
                          {nowTime === elem
                            ? 'امروز'
                            : calculateDateDifference(elem)}
                        </span>
                      </div>
                      <div>
                        {groupedTech[elem]?.reverse()?.map((item, index) => (
                          <div
                            className={classNames('flex flex-col w-full', {
                              'items-end':
                                String(
                                  userChatDetailData?.sender_profile.username,
                                ) !== String(item?.sender),
                              'items-start':
                                String(
                                  userChatDetailData?.sender_profile.username,
                                ) === String(item?.sender),
                              flashchat:
                                hash && hash.replace('#', '') === item.guid,
                            })}
                            key={index}
                          >
                            {item.product_info && (
                              <ReplyProduct
                                chat={item}
                                is_author={
                                  String(
                                    userChatDetailData?.sender_profile.username,
                                  ) === String(item?.sender)
                                }
                              />
                            )}
                            {((item.message !== null && item.message !== '') ||
                              item?.file_info !== null) && (
                              <div
                                className={classNames(
                                  'flex flex-col gap-4 px-4  py-2',
                                  {
                                    'items-start':
                                      String(
                                        userChatDetailData?.sender_profile
                                          .username,
                                      ) === String(item?.sender),

                                    'w-full': item.file_info,
                                  },
                                  {
                                    'items-end':
                                      String(
                                        userChatDetailData?.sender_profile
                                          .username,
                                      ) !== String(item?.sender),
                                    'w-fit': !item.file_info,
                                  },
                                )}
                                key={index}
                              >
                                <div
                                  ref={el =>
                                    (itemsRef.current[
                                      //@ts-ignore
                                      item?.guid
                                    ] = el)
                                  }
                                >
                                  <ChatmsgItem
                                    userChatDetailData={userChatDetailData}
                                    guid={item?.guid}
                                    chat={item}
                                    currentVideoPlaying={currentVideoPlaying}
                                    replyingChat={replyingChat}
                                    isDeleteChat={isDeleteChat}
                                    setIsDeleteChat={setIsDeleteChat}
                                    refresh={refetch}
                                    setReplyingChat={setReplyingChat}
                                    setcurrentVideoPlaying={
                                      setcurrentVideoPlaying
                                    }
                                    setParentChatGuid={setParentChatGuid}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
            </>
          </InfinitScroll>
        ) : isPageLoading ? (
          <div className=" h-full w-full flex justify-center items-center">
            <DotsLoading />
          </div>
        ) : (
          <div className=" h-full  flex flex-col justify-center items-center">
            <img src={EmptyList} alt="هیچ پیامی ندارید :(" />
          </div>
        )}
      </div>
      <ChatInputArea
        userChatDetailData={userChatDetailData}
        file={file}
        imageFile={imageFile}
        setFile={setFile}
        setImageFile={setImageFile}
        refresh={() => refetch()}
        chatId={guid}
        supplier_guid={state?.supplierGuid}
        dropDownIsOpen={dropDownIsOpen}
        setDropDownIsOpen={setDropDownIsOpen}
        replyingChat={replyingChat}
        setReplyingChat={setReplyingChat}
      />
      <BottomSheet
        onDismiss={() =>
          setIsDeleteChat({
            isOpen: false,
            data: null,
          })
        }
        open={isDeleteChat.isOpen}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
      >
        <div className="flex flex-col w-full px-3 gap-3 pb-4">
          <div className="flex w-full justify-between">
            <div className="flex">
              <SpanIcon className="icon-nameDelete text-[24px] text-red-500" />
              <div className="text-gray-950 font-Medium text-xl">حذف چت</div>
            </div>

            <button
              onClick={() =>
                setIsDeleteChat({
                  isOpen: false,
                  data: null,
                })
              }
            >
              <SpanIcon className="icon-nameClose-remove text-[24px] text-gray-700" />
            </button>
          </div>
          <div className="flex flex-col gap-3">
            <div className="text-gray-700 font-Medium text-md">
              آیا از حذف این چت اطمینان دارید؟{' '}
            </div>
          </div>
          <div className="w-full  flex justify-between">
            <button
              disabled={isloadingDelete}
              className="w-[45%] border-[1px] border-farm-shop-500 h-[48px] text-farm-shop-500 flex items-center justify-center text-md font-Medium rounded-[8px]"
              onClick={() => {
                mutate({
                  guid: isDeleteChat.data?.guid,
                  chatItem: isDeleteChat.data?.chatItem,
                });
              }}
            >
              {isloadingDelete ? <DotsLoading /> : 'بله،حذف شود'}
            </button>
            <button
              className="w-[45%] h-[48px] bg-farm-shop-500  text-white flex items-center justify-center text-md font-Medium rounded-[8px]"
              onClick={() =>
                setIsDeleteChat({
                  isOpen: false,
                  data: null,
                })
              }
            >
              انصراف
            </button>
          </div>
        </div>
      </BottomSheet>
      <ChatReport
        userChatDetailData={userChatDetailData}
        isReportOpen={isReportOpen}
        isDeleteOpen={isDeleteOpen}
        setIsReportOpen={setIsReportOpen}
        setIsDeleteOpen={setIsDeleteOpen}
      />
    </div>
  );
};

export default ChatsForm;
